import type {
  FeatureStatus,
  PartRequestStatus,
  PreventiveStatus,
  Priority,
  ServiceOrderStatus,
  VehicleStatus,
} from '@etnrlz/shared';

export interface StatusMeta {
  label: string;
  color: string;
}

export const partRequestStatusMeta: Record<PartRequestStatus, StatusMeta> = {
  SOLICITADA: { label: 'Solicitada', color: '#94a3b8' },
  PEDIDA: { label: 'Comprada', color: '#3b82f6' },
  EM_TRANSITO: { label: 'Em trânsito', color: '#f59e0b' },
  ENTREGUE: { label: 'Entregue', color: '#22c55e' },
  CANCELADA: { label: 'Cancelada', color: '#ef4444' },
};

export const osStatusMeta: Record<ServiceOrderStatus, StatusMeta> = {
  ABERTA: { label: 'Aberta', color: '#3b82f6' },
  EM_ANDAMENTO: { label: 'Em andamento', color: '#f59e0b' },
  AGUARDANDO_PECA: { label: 'Aguardando peça', color: '#a855f7' },
  PAUSADA: { label: 'Pausada', color: '#94a3b8' },
  CONCLUIDA: { label: 'Concluída', color: '#22c55e' },
  CANCELADA: { label: 'Cancelada', color: '#ef4444' },
};

export const priorityMeta: Record<Priority, StatusMeta> = {
  BAIXA: { label: 'Baixa', color: '#94a3b8' },
  MEDIA: { label: 'Média', color: '#3b82f6' },
  ALTA: { label: 'Alta', color: '#f59e0b' },
  URGENTE: { label: 'Urgente', color: '#ef4444' },
};

export const featureStatusMeta: Record<FeatureStatus, StatusMeta> = {
  ATIVO: { label: 'Ativo', color: '#22c55e' },
  VENCENDO: { label: 'Vencendo', color: '#f59e0b' },
  VENCIDO: { label: 'Vencido', color: '#ef4444' },
};

export const preventiveStatusMeta: Record<PreventiveStatus, StatusMeta> = {
  OK: { label: 'Em dia', color: '#22c55e' },
  VENCENDO: { label: 'Vencendo', color: '#f59e0b' },
  VENCIDA: { label: 'Vencida', color: '#ef4444' },
};

export const vehicleStatusMeta: Record<VehicleStatus, StatusMeta> = {
  ATIVO: { label: 'Ativo', color: '#22c55e' },
  EM_SERVICO: { label: 'Em serviço', color: '#f59e0b' },
  GUARDADO: { label: 'Guardado', color: '#94a3b8' },
};

export const featureTypeLabel: Record<string, string> = {
  PPF: 'PPF',
  SEGURO: 'Seguro',
  IPVA: 'IPVA',
  LICENCIAMENTO: 'Licenciamento',
  GARANTIA: 'Garantia',
  REVISAO: 'Revisão',
  CUSTOM: 'Outro',
};
